import { QueryClient, UseMutationResult } from "@tanstack/react-query"
import { useMutationWithRefresh } from "../utils"
import { saveAccountProject } from "../../../api/data"
import { UseMutationWithRefreshConfig } from "../utils/useMutationWithRefresh"
import { ProjectListTypes } from "@/types/program"

export const useSaveAccountProject = <
  TData,
  TError,
  TVariables extends { save: boolean },
>(
  queryClient: QueryClient,
  accountId: string,
  projectId: string,
  config: UseMutationWithRefreshConfig<TData, TError, TVariables> = {}
): UseMutationResult<TData, TError, TVariables, unknown> => {
  return useMutationWithRefresh(
    queryClient,
    (data: { save: boolean }) => saveAccountProject(accountId, projectId, data),
    {
      _onSuccess: (data) => {
        queryClient.setQueryData(
          ["accounts", accountId, "projects"],
          (oldData: ProjectListTypes) => {
            return {
              ...oldData,
              account_project_data: oldData.account_project_data.map(
                (project) =>
                  project.project_id === Number(projectId) ? data : project
              ),
            }
          }
        )

        queryClient.invalidateQueries({
          queryKey: ["accounts", "dashboard-accounts"],
        })
        queryClient.invalidateQueries({ queryKey: ["accounts", accountId] })
      },
      ...config,
    }
  )
}
